'use client';

import { useEffect, useMemo } from 'react';
import { useDataLayer } from '../dataLayer';
import { useDeliveryReturnsModal } from '../productDetails';
import { Hash } from './Hash';

export const useLinksObserver = () => {
    const { showPrivacyCenter } = useDataLayer();
    const { openModal: openDeliveryReturnsModal } = useDeliveryReturnsModal();

    const handlers: Partial<Record<Hash, () => void>> = useMemo(
        () => ({
            [Hash.CookiesPolicy]: showPrivacyCenter,
            [Hash.DeliveryReturnsModal]: openDeliveryReturnsModal,
        }),
        [showPrivacyCenter, openDeliveryReturnsModal],
    );

    const allowedHashes = useMemo(() => new Set(Object.values(Hash)), []);

    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement;
            const anchor = target.closest('a') as HTMLAnchorElement | null;
            if (!anchor) return;

            const hash = anchor.getAttribute('href');
            if (!hash || !allowedHashes.has(hash as Hash)) return;

            event.preventDefault();
            const handler = handlers[hash as keyof typeof handlers];
            if (typeof handler === 'function') {
                // scroll to the top
                window.scrollTo({ top: 0 });
                handler();
            }
        };

        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [handlers, allowedHashes]);
};
